import { EluveError, EluveErrorArgs } from './eluve-error';
import { LogLevel } from './types';

export class ValidationError extends EluveError {
  readonly name = 'ValidationError';
  readonly logLevel: LogLevel = 'error';

  constructor(message = 'Validation failed', args?: EluveErrorArgs) {
    super(message, args);
  }
}
